<template>
    <div>报警组列表</div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>

</style>